// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionFrequencySelect_container__3dYzm","icon":"SubscriptionFrequencySelect_icon__Qq8FU"};